import { useAppSelector } from '@app/hooks';
import { RootState } from '@app/store';
import NeighborhoodMap from '@features/neighborhood/components/NeighborhoodMap';
import { Box } from '@mui/material';
import { useMemo } from 'react';

const NeighborhoodMapView = () => {
  const userTenant = useAppSelector((state: RootState) => state.userTenant);
  const tenant = useAppSelector((state: RootState) => state.tenant);
  const currentTenant = useMemo(() => tenant.currentTenant || userTenant, [tenant.currentTenant, userTenant]);

  if (!currentTenant) return <></>;

  return (
    <Box sx={{ margin: '1em', padding: '1em' }}>
      <NeighborhoodMap />
    </Box>
  );
};

export default NeighborhoodMapView;
